// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
//引入富文本编辑
//import '../static/UE/ueditor.config.js'
//import '../static/UE/ueditor.all.min.js'
//import '../static/UE/lang/zh-cn/zh-cn.js'
//import '../static/UE/ueditor.parse.min.js'

import store from './store/index'
 
// or import all icons if you don't care about bundle size
   import 'vue-awesome/icons'
 
/* Register component with one of 2 methods */
 
import Icon from 'vue-awesome/components/Icon'
 
// globally (in your main .js file)
   Vue.component('icon', Icon)
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
import '@/assets/iconfont.css'
import router from './router'
import Validator from 'vue-validator'
Vue.use(Validator)
Vue.config.productionTip = false
Vue.use(ElementUI)
// Vue.use(Fontawesome)
/* eslint-disable no-new */
// 创建和挂载根实例





new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js